import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  webview: defineAsyncComponent(() => import("/app/layouts/webview.vue").then(m => m.default || m)),
  widget: defineAsyncComponent(() => import("/app/layouts/widget.vue").then(m => m.default || m))
}